import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectFundraiserReport } from 'app/manage-p2p/features/p2p.selectors';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { PeerToPeerDetailsListComponent } from '../peer-to-peer-details-list/peer-to-peer-details-list.component';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { CurrencyPipe } from '@angular/common';
import { P2pLinkPopoverComponent } from '../p2p-link-popover/p2p-link-popover/p2p-link-popover.component';
import { P2pTeamPopoverComponent } from '../p2p-team-popover/p2p-team-popover.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone:true,
  selector: 'app-peer-to-peer-team-card',
  templateUrl: './peer-to-peer-team-card.component.html',
  styleUrl: './peer-to-peer-team-card.component.scss',
  imports:[CurrencyPipe,P2pLinkPopoverComponent,P2pTeamPopoverComponent]
})
export class PeerToPeerTeamCardComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input () team = null;
  @Input () intid = '';
  
  public fundraiserReport$: any = this.store.pipe(
    select(selectFundraiserReport)
  );

  public donorReport = [];
  public teamFundraisers = [];
  public raised = 0;

  public image = '';
  public progressNgStyle = {};
  public progressValue = null;
  public donateUrlParams = {};
 
  constructor(
    public peerToPeerManageService: PeerToPeerManageService,
    private store: Store,
    private peerToPeerDetailsListComponent: PeerToPeerDetailsListComponent,
    private authService: AuthService,
  ){}

  ngOnInit(): void {
    this.image = this.team.image ? this.team.image : "/images/org_logo_default_v2.svg";

    this.fundraiserReport$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((donorReport)=> {
      this.donorReport = donorReport;

      this.teamFundraisers = this.donorReport.filter(donor => donor.teamId == this.team.id);
      this.teamFundraisers.forEach(fundraiser => this.raised += fundraiser.raised);

      this.progressValue = this.getProgressValue(this.raised, this.team.goal);
      this.progressNgStyle = {
        width: `${this.progressValue}%`
      }
    })

    this.authService.getOrgUser().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({handle}) => {
      const donateUrl = `${window.location.protocol}//${window.location.hostname}/handle/${handle}/campaign/${this.intid}/team/${this.team.id}`;
      
      this.donateUrlParams = {
        url: donateUrl,
        type: 'p2p-team',
        fileName: `${this.team.name}_donate_QR_Code`
      }
    })
  }

  viewTeamFundraisers() {
    this.peerToPeerDetailsListComponent.setActiveTab('champions');

    this.peerToPeerManageService.filterButtonText = this.team.name;
    this.peerToPeerManageService.category = this.team.id;
    this.peerToPeerManageService.filterP2pItems();
  }

  getProgressValue(raised, goal) {
    if(raised > goal) {
      return 100;
    }
    return (raised/goal) * 100;
  }
}
